import { OOHCategoryFormatColumn, OOHFormatColumn } from '../views/Plan/Grid/columns';
import { type PlanStrategy } from './type';

export const OOH: PlanStrategy = {
  KEY: 'OOH',
  TITLE: 'OOH plan',
  copyRow: (row) => {
    // comment?
    switch (row.kind) {
      case 'SMART':
        return {
          kind: row.kind,
          supplier: row.supplier,
          rate: row.rate,
        };

      case 'SERVICE':
      case 'MEDIA':
        return {
          kind: row.kind,
          supplier: row.supplier,
          unit: row.unit,
          gross_price: row.gross_price,
          client_price: row.client_price,
          provider_price: row.provider_price,
          smart: row.smart,
          // ooh
          ooh_category_format: row.ooh_category_format,
          ooh_location: row.ooh_location,
          ooh_format: row.ooh_format,
        };
      default:
        throw Error(`Unexpected kind: ${row.kind}`);
    }
  },
  canImportPlan: false,
  canExportMediaReservation: true,
  columns: [OOHCategoryFormatColumn, OOHFormatColumn],
};
